export const en = {
  newRequest: 'New request',
  userRequestsList: 'User requests list',
  defendantRequestsList: 'Defendant requests list',
  noSearchResultsFound: 'There are no results matching the entered data.',
  noRequestsFound: 'You have no requests.',
  noSearchResultsFoundDescription: 'Please check the data and try again.',
  noRequestsFoundDescription: 'You can create a new order.',
  search: 'Search...',
  requestType: 'Request type',
  requestStatus: 'Request status',
  sortBy: 'Sort by',
  timePeriod: 'Time period',
  theOldest: 'The oldest',
  theNewest: 'The newest',
  requestNumber: 'Request number',
  applicant: 'Applicant',
  applicantType: 'Applicant type',
  requestCategory: 'Request category',
  requestDate: 'Request date',
  meladiSuffix: 'M',
  actions: 'Actions',
  chooseTheAction: 'Choose action',
  financialClaim: 'Financial claim',
  contractNotification: 'Contract notification',
  actionsMenuLabel: 'Choose action',
  editRequestDetails: 'Edit request details',
  downloadBill: 'Download invoice',
  downloadCertificate: 'Download report',
  deleteRequest: 'Delete request',
  cancelRequest: 'Cancel request',
  payment: 'Payment',
  deleteRequestConfirmation: 'Are you sure to delete request',
  cancelRequestConfirmation: 'Are you sure to cancel the request',
  deleteRequestSuccessMessage: 'Request number {requestCode} has been deleted successfully.',
  cancelRequestSuccessMessage: 'Request number {requestCode} has been cancelled successfully.',
  dateOfReceipt: 'Date of receipt',
  applicantTypes: {
    bySelf: 'On behalf',
    byCompany: 'On company behalf',
    byTawkeel: 'By tawkeel',
  },
  jtpVerificationServiceText: 'You can inquire about the request if it does not appear in the list of requests through',
  jtpVerificationService: 'Judicial Tableegh verification service',
  noDefendantRequestsFound: 'There are no claims filed against you.',
  financialClaimRequestDescription: 'A service that allows the beneficiary to notify one of the parties to the contractual relationship of a request to fulfill his contractual obligations, in accordance with the requirements of the Commercial Courts System.',
  financialClaimRequest: 'Financial claim request',
  applicantInfo: 'Applicant info',
  partyTobeNotifiedData: 'Party to be notified data',
  requestData: 'Request data',
  requestPreview: 'Request preview',
  individual: 'Individual',
  organization: 'Organization',
  idNumber: 'National ID',
  phoneNumber: 'Phone number',
  email: 'Email',
  crNumber: 'CR number',
  crNumberHelperText: 'National facility number to be notified',
  iqamaOrNationalId: 'ID/Residence Number',
  iqamaOrNationalIdHelperText: 'ID number of the party to be notified',
  chooseTheAdjective: 'Choose the adjective',
  notificationType: 'Notification method',
  chooseNotificationType: 'Choose notification type',
  hintMobileAbsher: 'Alternative mobile number for the party to be notified in case there is no mobile number linked to the ID',
  hintMobileCR: 'An alternative mobile number for the facility to be notified in the event that there is no mobile number linked to the facility\'s national number',
  hintMobile: 'Mobile number of the recipient of judicial notices',
  absherEmailHint: 'Email of the party to be notified',
  CrEmailHint: 'Email of the facility to be notified',
  emailPlaceholder: 'example: example@mail.com',
  fulfillmentAmountLabel: 'Numeric fulfillment amount',
  fulfillmentAmountPlacehoder: 'Example: 1530',
  translatedFulfillmentAmountLabel: 'Translated fulfillment amount',
  translatedFulfillmentAmountPlacehoder: 'Example: One thousand five hundred and thirty Saudi riyals only',
  financialClaimRequestDetails: 'Financial Claim Request Details',
  financialClaimRequestDetailsPlaceholder: 'Enter claim request details',
  financialClaimRequestDetailsHint: 'The description must contain the subject of the dispute and the requests.',
  claimDocuments: 'Claim documents',
  claimDate: 'Claim date',
  claimDatePlaceholder: 'Enter the date of the financial claim',
  claimDateHint: 'You can choose a claim date from {numOfDays} days after submitting the application to apply to the court',
  claimDocumentsHint: 'File type must be ({maxFileSizeInMega}) maximum {extentions} MB',
  institutionName: 'Institution name',
  applicantName: 'Applicant name',
  applicantInformations: 'Applicant informations',
  byAttorneyNotice: 'By attorney notice',
  onBehalfNotice: 'On behalf notice',
  attorneyData: 'Attorney data',
  attorneyNumber: 'Attorney number',
  attorneyNumberPlaceholder: 'Enter attorney number',
  delegatedCRorNID: 'Delegated CR or NID',
  delegatedCRorNIDPlaceholder: 'Enter delegated CR or NID',
  verify: 'Verify',
  agentName: 'Agent name',
  agentId: 'Agent id',
  backToVerify: 'Back to verify',
  pleaseVerifyAttorneyData: 'Please verify attorney data',
  noticeText: 'Notice text',
  defendantWillRecieveTheFollowing: 'Defendant will recieve the following',
  paymentInfo: 'Payment info',
  amount: 'Amount (without vat)',
  vat: 'Vat',
  totalAmount: 'Total amount',
  consentText: 'I consent that I read',
  termsAndConditions: 'terms and conditions',
  retreat: 'retreat',
  backText: 'Back',
  approveConcent: 'Accept and agree',
  saveAndCompleteLater: 'Save and complete later',
  savingAsDraftProgress: 'Saving in progress ...',
  cancel: 'Cancel',
  requestsList: 'Requests list',
  saveAsDraftSuccessMessage: 'The request has been saved as a draft.',
  saveAsDraftDescription: 'You can complete the application later through the student list.',
  financialClaimNo: 'Financial claim {claimNumber}',
  copiedSuccessfully: 'Copied successfully',
  jtpVerification: 'Verify a judicial report',
  jtpVerificationDescription: 'An electronic service that allows checking incoming notifications',
  notificationMethodType: 'Notification method type',
  notificationMethodTypeHint: 'The notification method represents the way in which the financial message is received.',
  backToVerificationServices: 'Back to verification services',
  backToRequestsList: 'Back to requests list',
  newVerification: 'New verification',
  meladiShortcut: 'M',
  otherRequestInquiryBtn: 'Inquiry',
  profileValidation: {
    message: 'You cannot use the judicial reporting services because the account representative information is incomplete. Complete it now through',
    accountManagement: 'Account Management',
  },

  requestStatuses: {
    draft: 'Draft',
    waitingForPayment: 'Waiting for payment',
    completed: 'Completed',
    deleted: 'Deleted',
    schedule: 'Schedule',
  },

  validations: {
    fieldIsRequired: 'Field is required',
    dateAfterDays: 'Claim date should be after {days} days equivalent to {equivalent}',
  },
};
